import env from '@beam-australia/react-env';

import { ENV_CONFIG_ATTRIBUTES } from 'app/config/env-config-attributes';

const config = {
    HOME_PAGE_URL: env(ENV_CONFIG_ATTRIBUTES.HOME_PAGE_URL),
    LANGUAGE: env(ENV_CONFIG_ATTRIBUTES.LANGUAGE),
    MY_PAGES_URL: env(ENV_CONFIG_ATTRIBUTES.MY_PAGES_URL),
    CUSTOMER_SERVICE: env(ENV_CONFIG_ATTRIBUTES.CUSTOMER_SERVICE_URL),
    auth: {
        redirectUri: env(ENV_CONFIG_ATTRIBUTES.REDIRECT_URI),
        authTheme: env(ENV_CONFIG_ATTRIBUTES.AUTH_THEME),
        clientId: env(ENV_CONFIG_ATTRIBUTES.CLIENT_ID),
        scope: env(ENV_CONFIG_ATTRIBUTES.SCOPE),
        authUrl: env(ENV_CONFIG_ATTRIBUTES.AUTH_URL),
        tokenUrl: env(ENV_CONFIG_ATTRIBUTES.TOKEN_URL),
    },
    version: env(ENV_CONFIG_ATTRIBUTES.VERSION),
    sentryUrl: env(ENV_CONFIG_ATTRIBUTES.SENTRY_URL),
};

export { config };
